import { useQuery } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getFeedbackTable, getLandingPageFeedbackStats } from 'services/continuousFeedback';

const getData = async ({ feedbackStatus, offset, limit, employeeId }) => {
  try {
    const res = await getFeedbackTable({
      feedbackStatus,
      offset,
      limit,
      employeeId,
    });
    const { columns = [], values = [] } = res ?? {};
    return { columns, values };
  } catch (err) {
    console.error('Error fetching feedback table data, err : ', err);
  }
};

// react-query approach

const useCFTableData = ({ feedbackStatus, offset = 0, limit = 1000, employeeId = null }) =>
  useQuery(
    ['CFTable', feedbackStatus, offset, limit],
    () => {
      if (feedbackStatus) {
        return getData({
          feedbackStatus,
          offset,
          limit,
          employeeId,
        });
      }
    },
    { enabled: !!feedbackStatus }
  );

const useCFTabsData = () => useQuery([REACT_QUERY_KEYS.CFTabs], getLandingPageFeedbackStats);

// const useCFTableData = ({ feedbackStatus, offset = 0, limit = 10, forceUpdateValue }) => {
//   const { isLoading, run, isIdle } = useAsync();
//   const [data, setData] = useState({ values: [], columns: [] });

//   useEffect(() => {
//     if (feedbackStatus) {
//       run(
//         getData({
//           feedbackStatus,
//           offset,
//           limit,
//           setData
//         })
//       );
//     }
//   }, [feedbackStatus, offset, limit, forceUpdateValue]);

//   return { data, isLoading, isIdle };
// };

export { useCFTableData, useCFTabsData };
